module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('style-loaders'), _vm._v(" "), _c('header', [_c('span', [_c('button', {
    staticClass: "menuButton",
    attrs: {
      "aria-label": "apri menu"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-bars"
  }), _c('span', {
    staticStyle: {
      "display": "none !important"
    }
  }, [_vm._v("menu")])]), _vm._v("\n\t\t\tGara di rutti\n\t\t")])]), _vm._v(" "), _c('main', [_c('menu-gdr', {
    attrs: {
      "open": _vm.menuOpened
    }
  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (!_vm.cookieOk) ? _c('div', {
    staticClass: "cookie-panel"
  }, [_vm._v("\n\t\tquesto sito usa cookie\n\t\t"), _c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_vm._v("\n\t\t\tCookie Policy\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn-cookie-cont"
  }, [_c('button', {
    staticClass: "btn-cookie",
    on: {
      "click": _vm.okCookie
    }
  }, [_vm._v("Accetto")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92580a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 58
// module chunks = 7